import { getReceipts } from "../../../services/AsadaApi";

const pajaReceiptsConsumer = (pajaId, signal) => {
  getReceipts(pajaId, signal);
}

export default pajaReceiptsConsumer;